// const CryptoJS = require('crypto-js')
import CryptoJS from 'crypto-js'

// 修改密码时获取加密传参的key
export const desChangePwdKey = 'zxzx119.'

// DES 加密（ECB 模式，Pkcs7 填充）
export function desEncrypt(plaintext: String, key: String) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.DES.encrypt(plaintext, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

// DES 解密
export function desDecrypt(ciphertext: String, key: String) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
